// Translator notes: Finnish clause constructions (engine/src/finnish-constructions.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  fiShould: {
    args: ['verb'],
    fi: (a: string[]) =>
      `”Pitäisi” ja ”olisi pitänyt” käännettiin verbillä ${a[0]}: ensin infinitiivi, sitten se, jonka pitäisi, akkusatiivissa ja lopuksi verbi (”Jorilagon avy sytilības” = sinun pitäisi levätä).`,
    en: (a: string[]) =>
      `“Pitäisi” and “olisi pitänyt” (should, should have) were translated with ${a[0]}: the infinitive, then the one who should in the accusative, then the verb (“Jorilagon avy sytilības” = you should rest).`,
  },
  fiSentenceAdverb: {
    args: ['word', 'verb'],
    fi: (a: string[]) =>
      `”${a[0]}” on valyriassa oma lauseensa: verbi ${a[1]} (toivon), ja toivottu asia on sen edellä subjunktiivissa (”Rytsa iksō jaelan” = toivottavasti voit hyvin).`,
    en: (a: string[]) =>
      `“${a[0]}” is a clause of its own in Valyrian: the verb ${a[1]} (I hope), with the hoped-for clause before it in the subjunctive (“Rytsa iksō jaelan” = I hope you are well).`,
  },
  fiState: {
    args: ['word', 'hv'],
    fi: (a: string[]) => `”${a[0]}” kertoo olotilasta, joten se käännettiin olla-verbillä ja sanalla ${a[1]} (”Rytsa iksan” = voin hyvin).`,
    en: (a: string[]) => `“${a[0]}” describes a state, so it was translated with “be” and ${a[1]} (“Rytsa iksan” = I am well).`,
  },
  fiProgressive: {
    args: ['word', 'hv'],
    fi: (a: string[]) => `”Olla ${a[0]}” on valyriassa tavallinen verbi ${a[1]} (”Sōnar māzis” = talvi on tulossa).`,
    en: (a: string[]) => `“Olla ${a[0]}” (be …-ing) is the plain verb ${a[1]} in Valyrian (“Sōnar māzis” = winter is coming).`,
  },
  fiResultative: {
    args: ['word', 'verb'],
    fi: (a: string[]) => `”Tehdä joku ${a[0]}” käännettiin yhdellä verbillä, ${a[1]} (”Yne jessiēdā” = olet tehnyt minut iloiseksi).`,
    en: (a: string[]) => `“Make someone ${a[0]}” was translated with one verb, ${a[1]} (“Yne jessiēdā” = you have made me happy).`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
